<template>
    <div>
      <Head title="Marcas" />
      <h1 class="mb-8 text-3xl font-bold">Marcas</h1>
      <div class="flex items-center justify-between mb-6">
        <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
      </search-filter>
        <Link class="btn-blue" href="/brands/create">
          <span>Create</span>
          <span class="hidden md:inline">&nbsp;Marcas</span>
        </Link>
      </div>
      <div class="bg-white rounded-md shadow overflow-x-auto">
        <table class="w-full whitespace-nowrap">
          <thead>
            <tr class="text-left font-bold">
              <th class="pb-4 pt-6 px-6">Nombre</th>
              <th class="pb-4 pt-6 px-6">Código</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="brand in brands.data" :key="brand.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
              <td class="border-t">
                <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/brands/${brand.id}/edit`">
                  {{ brand.name }}
                  <icon v-if="brand.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/brands/${brand.id}/edit`">
                  {{ brand.code }}
                  <icon v-if="brand.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
                </Link>
              </td>
            </tr>
            <tr v-if="brands.data.length === 0">
              <td class="px-6 py-4 border-t" colspan="4">No encontramos marcas.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <pagination class="mt-6" :links="brands.meta.links" />
    </div>
  </template>
  
  <script>
  import { Head, Link } from '@inertiajs/inertia-vue3'
  import Icon from '@/Shared/Icon'
  import pickBy from 'lodash/pickBy'
  import Layout from '@/Shared/Layout'
  import throttle from 'lodash/throttle'
  import mapValues from 'lodash/mapValues'
  import Pagination from '@/Shared/Pagination'
  import SearchFilter from '@/Shared/SearchFilter'
  
  export default {
    components: {
      Head,
      Icon,
      Link,
      Pagination,
      SearchFilter,
    },
    layout: Layout,
    props: {
      filters: Object,
      brands: Object,
    },
    data() {
      return {
        form: {
          search: this.filters.search,
        },
      }
    },
    watch: {
      form: {
        deep: true,
        handler: throttle(function () {
          this.$inertia.get('/brands', pickBy(this.form), { preserveState: true })
        }, 150),
      },
    },
    methods: {
      reset() {
        this.form = mapValues(this.form, () => null)
      },
    },
  }
  </script>
  